import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import type { ReactNode } from 'react';
import React from 'react';
import styles from './BottomSheet.module.scss';

export interface BottomSheetProps {
	children: ReactNode;
	isOpen: boolean;
	onClose: () => void;
	background?: string;
	borderRadius?: number;
	className?: string;
}
export function BottomSheet({
	background = '#1F2145',
	borderRadius = 12,
	children,
	isOpen,
	onClose,
	className,
}: BottomSheetProps) {
	return (
		<AnimatePresence>
			{isOpen ? (
				<motion.div
					className={styles.container}
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					onClick={() => {
						onClose();
					}}
				>
					<motion.div
						initial={{ y: 500 }}
						animate={{ y: 0 }}
						exit={{ y: 500 }}
						transition={{ duration: 0.2, ease: 'easeIn' }}
						drag='y'
						dragElastic={{ bottom: 0.5, top: 0 }}
						className={clsx(styles.inner, className || '')}
						dragConstraints={{
							bottom: 0,
							top: 0,
						}}
						style={{
							backgroundColor: background,
							borderTopLeftRadius: `${borderRadius}px`,
							borderTopRightRadius: `${borderRadius}px`,
						}}
						onClick={(e) => e.stopPropagation()}
						onDragEnd={(e, info) => {
							if (info.offset.y >= 50) {
								onClose();
							}
						}}
					>
						<motion.div className={styles.grip}></motion.div>
						<div className={styles.content}>{children}</div>
					</motion.div>
				</motion.div>
			) : null}
		</AnimatePresence>
	);
}
